import React, { useState } from "react";
import "../../components/Page/page_header.css";
import { useSidebar } from "../../components/ui/sidebar";
import Denda from "./Logos/Denda.png";
import Azerion from "./Logos/Azerion.png";
import CNN from "./Logos/CNN.png";
import DPG from "./Logos/dpg.png";
import { useNavigate } from "react-router-dom";
import { UserRoundCog, LogOut, User, Settings } from "lucide-react";
import { Avatar, AvatarImage, AvatarFallback } from "../../components/ui/avatar";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "../../components/ui/dropdown";
import { post } from "../../lib/api";

export const Profile = () => {
  const { setAuthenticated, setSidebarOpen } = useSidebar();

  const navigate = useNavigate();

  const userIcons = {
    // a dictionary mapping brand names to their icons, names are the keys and the icons are the values
    Denda: Denda,
    CNN: CNN,
    DPG: DPG,
    Azerion: Azerion,
  };

  function handlePage(page) {
    navigate(`/${page}`);
  }

  const handleLogout = async () => {
    post({}, "/logout");

    setAuthenticated(false);
    setSidebarOpen(false);
  };

  // Get the current brand value from the app context
  const { brand } = useSidebar();

  return (
    <div className="user-profile">
      {/* Main container for the profile section */}

      <DropdownMenu>
        {/* Trigger the dropdown when avatar is clicked */}
        <DropdownMenuTrigger asChild>
          <Avatar sx={{ cursor: "pointer" }}>
            <AvatarImage src={userIcons[brand]} alt="User Avatar" />
            <AvatarFallback>`${[brand]}`</AvatarFallback>
          </Avatar>
        </DropdownMenuTrigger>

        <DropdownMenuContent className="text-black">
          {/*<DropdownMenuLabel>*/}
          {/*  /!*<span className="text-xl"> *!/*/}
          {/*    My Account*/}
          {/*  /!*</span>*!/*/}
          {/*</DropdownMenuLabel>*/}


          <DropdownMenuItem onClick={() => handlePage(`Profile`)}>
            <User className="size-5 font-bold" />
            {/*<span className="text-xl">*/}
             Profile
            {/*</span>*/}
          </DropdownMenuItem>

          <DropdownMenuItem onClick={() => handlePage(`Administration`)}>
            <UserRoundCog className="size-4 font-bold" />
            {/*<span className="text-xl"> */}
              Administration
            {/*</span>*/}
          </DropdownMenuItem>

          <DropdownMenuItem>
            <Settings className="size-4 font-bold" />
            {/*<span className="text-xl"> */}
            Settings
          {/*</span>*/}
          </DropdownMenuItem>

          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleLogout}>
            <LogOut className="dropdown-icon" /> Logout
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default Profile;
